
















import { Vue, Component, Prop } from "vue-property-decorator";
import EventModel from "@/models/event/eventModel";
import moment from "moment";
import tinycolor from "tinycolor2";

@Component
export default class EventCell extends Vue {
  @Prop(String) readonly month!: string;
  @Prop(Object) readonly event!: EventModel;

  private cellWidth = 60;
  private borderWidth = 2;
  private hover = false;

  get eventWidth() {
    const start = moment(this.event.startDate);
    const end = moment(this.event.endDate);
    let days = 0;

    while (start <= end) {
      if (start.format("MMM") === this.month) {
        days++;
      }

      start.add(1, "days");
    }

    return this.cellWidth * days - this.borderWidth + "px";
  }

  get backgroundColor() {
    const color = tinycolor(this.event.eventCategory.colour);

    return this.hover
      ? color.darken().toHexString()
      : this.event.eventCategory.colour;
  }

  get backgroundIsLight() {
    const color = tinycolor(this.backgroundColor);

    return color.isLight();
  }
}
